import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import store  from '@/store'
import VueAnalytics from 'vue-analytics'

// for pretty-printing JSON during dev
// https://www.npmjs.com/package/vue-json-pretty
import VueJsonPretty from 'vue-json-pretty'
Vue.component('VueJsonPretty', VueJsonPretty);
 
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'

// My Components
import Home from './components/home.vue';
import Account from './components/account.vue';
import Dashboard from './components/dashboard';
import Pricing from './components/pricing/index.vue';

// Fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSignInAlt, faHeart, faArrowsAlt, faUnlink } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faSignInAlt, faHeart, faArrowsAlt, faUnlink)
Vue.component('font-awesome-icon', FontAwesomeIcon);

// importa tailwind
import '@/assets/tailwind.css'


if (!process.env.NODE_ENV) {
  // Disable console logs in production
  if(window){
    window.console.log=function(){};
  }
}


Vue.use(VueRouter)
Vue.use(firestorePlugin)

var firebaseConfig = {
      apiKey: process.env.VUE_APP_firebase_apiKey,
      authDomain: process.env.VUE_APP_firebase_authDomain,
      databaseURL: process.env.VUE_APP_firebase_databaseURL,
      projectId: process.env.VUE_APP_firebase_projectId,
      storageBucket: process.env.VUE_APP_firebase_storageBucket,
      messagingSenderId: process.env.VUE_APP_firebase_messagingSenderId,
      appId: process.env.VUE_APP_firebase_appId
    };


const routes = [
	{ path: '/', component: Home },
  { path: '/dash/:dashboard', component: Dashboard },
  { path: '/account', component: Account },
  { path: '/Pricing', component: Pricing }
]

const router = new VueRouter({
  routes, // short for `routes: routes`
  mode: 'history'
})

const isProd = process.env.NODE_ENV === 'production';
// Analytics
// https://matteogabriele.gitbooks.io/vue-analytics/content/
Vue.use(VueAnalytics, {
  id: 'UA-42920430-24',
  router,
  debug: {
    enabled: false, //  use !isProd to see debug stuff in dev
    sendHitTask: isProd
  }
})

Vue.config.productionTip = false

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
console.log('fbdbUrl:', firebaseConfig.databaseURL)

let unsubscribe = firebase.auth().onAuthStateChanged(user => {
  if (user) {
    // User is signed in.
    // console.log('we have a user:', user);
    store.dispatch('setUserAuth', user)
    store.dispatch('getUserData', user)
      .then( () =>startApp())
  } else {
    // No user is signed in.
    store.dispatch('setAuthChecked', true)
    startApp()
  }
  // unsubscribe from auth change
  unsubscribe()
});

export const db = firebase.firestore();

const startApp = function() {
  new Vue({
    render: h => h(App),
    router: router,
    store: store
  }).$mount('#app')
}

// docs for vuefire: 
// https://vuefire.vuejs.org/vuefire/binding-subscriptions.html#declarative-binding
// https://blog.bitsrc.io/build-a-vue-app-with-firebase-authentication-and-database-e7d6816f79af







